import * as React from 'react';
import ReactPaginate from 'react-paginate';
import {ArrowDown} from "./icons/icons";

export const defaultPagination = {
  totalRecords: 10,
  currentPage: 0,
  totalPages: 10,
  nextPage: 1,
  prevPage: 0,
  postsPerPage: 9,
};

export interface PaginationInterface {
  totalRecords: number,
  currentPage: number,
  totalPages: number,
  nextPage: number,
  prevPage: number,
  postsPerPage: number,
}

const Pagination = (props: { pagination: PaginationInterface, setPaginationStep: (pageNumber: number) => void }) => {

  const {pagination, setPaginationStep} = props;
  const {postsPerPage, totalRecords, totalPages, currentPage} = pagination;

  const paginationNumbers = [];

  for (let i = 1; i <= Math.ceil(totalRecords / postsPerPage); i++) {
    paginationNumbers.push(i);
  }

  return (
    <div className="pagination">
      <ReactPaginate
        breakLabel="..."
        forcePage={currentPage}
        onPageChange={(selectedItem: {selected: number}) => {
          console.log("selectedItem", selectedItem);
          setPaginationStep(selectedItem.selected)
        }}
        pageRangeDisplayed={3}
        pageCount={totalPages}
        previousLabel={<ArrowDown/>}
        nextLabel={<ArrowDown/>}
        pageClassName="pagination-list__item"
        pageLinkClassName="pagination-list__item-link"
        previousClassName="pagination-list__item--prev"
        previousLinkClassName="pagination-list__item-link"
        nextClassName="pagination-list__item--next"
        nextLinkClassName="pagination-list__item-link"
        breakClassName="page-item"
        breakLinkClassName="pagination-list__item-link"
        containerClassName="pagination-list"
        activeClassName="pagination-list__item--active"
        renderOnZeroPageCount={null}
      />
      {/*<ul className="pagination-list">*/}
      {/*  {currentPage > 0 ? (*/}
      {/*    <li onClick={() => setPaginationStep(currentPage - 1)}*/}
      {/*        className={"pagination-list__item pagination-list__item--prev"}>*/}
      {/*      <ArrowDown/>*/}
      {/*    </li>*/}
      {/*  ) : null}*/}
      {/*  {paginationNumbers.map((pageNumber) => {*/}
      {/*    const isActive = currentPage === pageNumber;*/}
      {/*    return (*/}
      {/*      <li key={pageNumber}*/}
      {/*          onClick={() => setPaginationStep(pageNumber)}*/}
      {/*          className={"pagination-list__item" + (isActive ? " pagination-list__item--active" : "")}>*/}
      {/*        {pageNumber}*/}
      {/*      </li>*/}
      {/*    )*/}
      {/*  })}*/}
      {/*  {currentPage + 1 < totalPages ? (*/}
      {/*    <li onClick={() => setPaginationStep(currentPage + 1)}*/}
      {/*        className={"pagination-list__item pagination-list__item--next"}>*/}
      {/*      <ArrowDown/>*/}
      {/*    </li>*/}
      {/*  ) : null}*/}
      {/*</ul>*/}
    </div>
  );
};

export default Pagination;
